import React from "react";
import {getTranslation} from "domain/helpers/translations";
import {FormattedMessage} from "react-intl";

// value-carrying chips of the Price and Sales tabs: "Prix min : 10 €"
const VALUE_FILTER_LABELS = {
    'PriceMin': {labelId: 'merchandising.show.label.filters.price.min', unit: '€'},
    'PriceMax': {labelId: 'merchandising.show.label.filters.price.max', unit: '€'},
    'DiscountMin': {labelId: 'merchandising.show.label.filters.discount.min', unit: '%'},
    'DiscountMax': {labelId: 'merchandising.show.label.filters.discount.max', unit: '%'},
    'SalesMin': {labelId: 'merchandising.show.label.filters.sales.min', unit: ''},
};

// prefixed chips of the Scoring tab: "Benchmark : Plus cher", "Demande : Élevé"
const SCORING_FILTER_PREFIX_IDS = {
    'Benchmark': 'merchandising.show.label.filters.benchmark',
    'Demand': 'merchandising.show.label.filters.demand',
};

export function getFilterLabel(item, asString) {

    if (item['@type'] === 'Retailer' || item['@type'] === 'Brand' || item['@type'] === 'Channel') {
        return item.name;
    }

    const valueLabel = VALUE_FILTER_LABELS[item['@type']];
    if (valueLabel) {
        const value = valueLabel.unit ? `${Number(item.value).toLocaleString()} ${valueLabel.unit}` : Number(item.value).toLocaleString();

        return asString
            ? value
            : <><FormattedMessage id={valueLabel.labelId} /> : {value}</>;
    }

    const scoringPrefixId = SCORING_FILTER_PREFIX_IDS[item['@type']];
    if (scoringPrefixId) {
        return asString
            ? item.name
            : <><FormattedMessage id={scoringPrefixId} /> : <FormattedMessage id={"merchandising.show.label.filters." + item.name} /></>;
    }

    if (!item.translations) {
        return asString ? item.name : <FormattedMessage id={"merchandising.show.label.filters." + item.name} />;
    }

    const translations = getTranslation(item);
    if (Object.hasOwn(translations, 'name')) {
        return translations.name;
    }

    if (Object.hasOwn(translations, 'value')) {
        return translations.value;
    }

    throw Error('Could not find a valid translation for filter ' + item.id);
}
